import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { format, parse } from "date-fns";

const formatTimeRange = (startTime, endTime) => {
  const start = parse(String(startTime || "00:00"), "HH:mm", new Date());
  const end = parse(String(endTime || "00:00"), "HH:mm", new Date());
  return `${format(start, "h:mm a")} - ${format(end, "h:mm a")}`;
};

const DayView = ({ cursor, getEventsForDayAndSlot, onBatchClick, slots, instituteTimingLabel }) => {
  const activeCount = slots.reduce(
    (sum, slot) => sum + getEventsForDayAndSlot(cursor, slot).length,
    0
  );

  
  return (
    <Paper variant="outlined" elevation={0} sx={{ borderRadius: 3, overflow: "hidden" }}>
      <Box sx={{ p: 1.5, borderBottom: "1px solid", borderColor: "divider" }}>
        <Typography variant="h6" sx={{ fontSize: 18 }}>
          {format(cursor, "EEEE")}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {format(cursor, "d MMMM yyyy")} - {activeCount} active batch
          {activeCount === 1 ? "" : "es"}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Institute timing: {instituteTimingLabel}
        </Typography>
      </Box>

      <Box sx={{ display: "flex" }}>
        <Box sx={{ width: 70, borderRight: "1px solid", borderColor: "divider" }}>
          {slots.map((slot) => (
            <Box
              key={slot.key}
              sx={{
                height: 54,
                px: 0.75,
                py: 0.25,
                borderBottom: "1px solid",
                borderColor: "divider",
              }}
            >
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
                {slot.label}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box sx={{ flex: 1 }}>
          {slots.map((slot) => {
            const events = getEventsForDayAndSlot(cursor, slot);
            return (
              <Box
                key={slot.key}
                sx={{
                  minHeight: 54,
                  p: 0.75,
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  alignItems: "flex-start",
                }}
              >
                {events.map((batch) => (
                  <Paper
                    key={`${slot.key}-${batch.id}`}
                    variant="outlined"
                    onClick={() => onBatchClick(batch)}
                    sx={{
                      borderRadius: 1,
                      p: "4px 8px",
                      cursor: "pointer",
                      bgcolor: batch.color.bg,
                      color: batch.color.text,
                      borderColor: "divider",
                    }}
                  >
                    <Typography sx={{ fontSize: 11, fontWeight: 700 }}>
                      {batch.label}
                    </Typography>
                    <Typography sx={{ fontSize: 10 }}>
                      {batch.instructor} - {batch.students} students -{" "}
                      {formatTimeRange(batch.startTime ?? batch.time, batch.endTime ?? batch.time)}
                    </Typography>
                  </Paper>
                ))}
                {events.length === 0 ? (
                  <Typography variant="caption" color="text.disabled">
                    Free for trainer
                  </Typography>
                ) : null}
              </Box>
            );
          })}
        </Box>
      </Box>
    </Paper>
  );
};

export default DayView;
